import mixpanel from 'mixpanel-browser';

const integrations = {
  mixpanel: {
    enabled: !!process.env.NEXT_PUBLIC_MIXPANEL_KEY.length,
    init: () => mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_KEY)
  }
};

Object.keys(integrations).forEach((key) => {
  if (integrations[key].enabled) integrations[key].init();
});

const actions = {
  identify: (id) => {
    if (integrations.mixpanel.enabled) mixpanel.identify(id);
  },
  alias: (id) => {
    if (integrations.mixpanel.enabled) mixpanel.alias(id);
  },
  track: (name, props = {}, sendImmediately = false) => {
    const options = { send_immediately: sendImmediately };
    if (integrations.mixpanel.enabled)
      mixpanel.track(name, { ...props, variant: 'next' }, options);
  },
  people: {
    set: (props) => {
      if (integrations.mixpanel.enabled) mixpanel.people.set(props);
    }
  }
};

const Tracking = actions;

export default Tracking;
